import { textFilter } from "react-bootstrap-table2-filter";
import {
  DeepMergeObject,
  DotStringToObject,
  GetHeaderStyle,
  GetNormalStyle,
} from "../core/Helper";

export const SearchPatientRight = (props) => {
  const [setSearchB, data, setData, userInfo, item] = props;
  //** ชื่อฟิลด์ data สำหรับรับข้อมูล */
  const idFieldName = "patrightid";
  const displayFieldName = "patrightname";

  setSearchB({
    title: "สิทธิการรักษา",
    size: "lg",
    show: true,
    fieldId: idFieldName,
    fieldName: "patrightname",

    sql: {
      fields: ["patrightid", "patrightcode", "patrightname"],
      tableName: "ba_patient_right a ",
      defaultCriteria: " a.del_flag ='n' ",
      criteriaFields: ["a.patrightcode", "a.patrightname"],
      criteriaText: "",
      orderBy: ["a.patrightname"],
      maxRows: 3000,
    },
    /** เมื่อคลิกเลือกรายการ */
    action: (result) => {
      setData((pv) => ({
        ...pv,
        ...DeepMergeObject(
          DotStringToObject(
            item.fieldName + "." + item.searchValueName,
            result[idFieldName]
          ),
          DotStringToObject(
            item.fieldName + "." + item.searchDisplayName,
            result[displayFieldName]
          )
        ),
      }));
      setSearchB((pv) => ({ ...pv, show: false }));
    },
    columns: [
      {
        dataField: "patrightcode",
        text: "รหัส",
        sort: true,
        headerStyle: GetHeaderStyle("120px"),
        style: () => GetNormalStyle("center"),
        filter: textFilter({ placeholder: "..." }),
      },
      {
        dataField: "patrightname",
        text: "ชื่อสิทธิรักษา",
        sort: true,
        headerStyle: GetHeaderStyle("auto"),
        style: () => GetNormalStyle("left"),
        filter: textFilter({ placeholder: "..." }),
      },
    ],
  });
};

export const SearchBranchPatientRight = (props) => {
  const [setSearchB, data, setData, userInfo, item] = props;
  //** ชื่อฟิลด์ data สำหรับรับข้อมูล */
  const idFieldName = "brchpatrightid";
  const displayFieldName = "brchright_name";

  setSearchB({
    title: "สิทธิการรักษา",
    size: "lg",
    show: true,
    fieldId: idFieldName,
    fieldName: "brchright_name",
    sql: {
      fields: ["brchpatrightid", "brchpatrightcode", "brchright_name"],
      tableName: "brch_patient_right a ",
      defaultCriteria: ` a.del_flag ='n' and brchid=${userInfo.brchid} `,
      criteriaFields: ["a.brchpatrightcode", "a.brchright_name"],
      criteriaText: "",
      orderBy: ["a.brchright_name"],
      maxRows: 3000,
    },
    /** เมื่อคลิกเลือกรายการ */
    action: (result) => {
      setData((pv) => ({
        ...pv,
        ...DeepMergeObject(
          DotStringToObject(
            item.fieldName + "." + item.searchValueName,
            result[idFieldName]
          ),
          DotStringToObject(
            item.fieldName + "." + item.searchDisplayName,
            result[displayFieldName]
          )
        ),
      }));
      setSearchB((pv) => ({ ...pv, show: false }));
    },
    columns: [
      {
        dataField: "brchpatrightcode",
        text: "รหัส",
        sort: true,
        headerStyle: GetHeaderStyle("120px"),
        style: () => GetNormalStyle("center"),
        filter: textFilter({ placeholder: "..." }),
      },
      {
        dataField: "brchright_name",
        text: "ชื่อสิทธิรักษา",
        sort: true,
        headerStyle: GetHeaderStyle("auto"),
        style: () => GetNormalStyle("left"),
        filter: textFilter({ placeholder: "..." }),
      },
    ],
  });
};
